 /* eslint-disable */
import { defineStore } from 'pinia';
import _ from 'lodash';

import LaternaMenu from '../components/landing/laterna/Menu.vue';
import LaternaCasinoGames from '../components/landing/laterna/CasinoGames.vue'
import LaternaLiveCasinoGames from '../components/landing/laterna/LiveCasinoGames.vue'
import LaternaCasinoCategoryGames from '../components/landing/laterna/CasinoCategoryGames.vue'
import LaternaSportHighlights from '../components/landing/laterna/SportHighlights.vue'
import PopularCompetitions from '../components/landing/laterna/PopularCompetitions.vue';
import HomeSportHighlights from '../components/Home/sports/Highlights.vue';
import LandingQuickPicks from '../components/Home/sports/LandingQuickPicks.vue';

import { usePlatformConfigurationStore } from './platform_configuration';
import { useInitializeStore } from './initialize';


export const useLaternaStore = defineStore('laternaStore', {
	state: () => ({
		landing_page_sections: [],
		component_registry: {
			'desktop': {
				'casino': LaternaCasinoGames,
				'live_casino': LaternaLiveCasinoGames,
				'top_competitions': PopularCompetitions,
				'menu': LaternaMenu,
				'casino_category': LaternaCasinoCategoryGames,
				'popular_games': LaternaSportHighlights,
				'quick_picks': LandingQuickPicks
			},
			'mobile': {
				'casino': LaternaCasinoGames,
				'live_casino': LaternaLiveCasinoGames,
				'top_competitions': PopularCompetitions,
				'menu': LaternaMenu,
				'casino_category': LaternaCasinoCategoryGames,
				'sport_highlights': HomeSportHighlights,
				// 'popular_games': LaternaSportHighlights,
				'quick_picks': LandingQuickPicks
			}
		}
	}),
	getters: {
		getRegistry(state) {
			if (useInitializeStore().screenWidth > 767) return state.component_registry.desktop;
			return state.component_registry.mobile;
		},
		getLandingPageSections(state) {
			return _.orderBy(state.landing_page_sections, 'sort', 'asc');
		}
	},
	actions: {
		fetchLandingSections() {
			if (!usePlatformConfigurationStore().isLaternaEnabled) return Promise.resolve();

			const initializeStore = useInitializeStore();
			const device = initializeStore.isMobile ? 'mobile' : 'desktop';

			return global.axios.get(process.env.VUE_APP_API_URL + '/landing-page-sections', { params: { device: device } }).then((response) => {
				this.landing_page_sections = response.data.data
				return Promise.resolve(response.data.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		fetchLandingSectionItems(id) {
			const initializeStore = useInitializeStore();
			const device = initializeStore.isMobile ? 'mobile' : 'desktop';

			return global.axios.post(process.env.VUE_APP_API_URL + '/landing-page-sections/items', { id, device }).then((response) => {
				return Promise.resolve(response.data.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
	},
})